@if (isCreatingNew === false && isCreatingNewOnboarding === false){
  <div class="pageheader">
    <div class="page-title">
      <h1>Partner Search Details</h1>
      <div class="btn-group">
        <button class="btn btn-link" [disabled]="!selectedPartner || isEditing"
          (click)="refresh($safeNavigationMigration(selectedPartner?.PartnersId))">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
          <button class="btn btn-link" id="btnNew" *bizPermissionRequired="'Partner_Action_PartnerCreate'"
            (click)="createNew()" [disabled]="isEditing">Create new <ep-svg-icon icon="plus"></ep-svg-icon></button>
            <button class="btn btn-link" id="btnNew" (click)="addToFavorite()" [disabled]="isEditing">Add to favorites
              <ep-svg-icon icon="plus"></ep-svg-icon></button>
              <app-change-log-link *bizPermissionRequired="'Partner_Action_ShowLog'" [disabled]="!selectedPartner"
                [title]="'Logs for ' + $safeNavigationMigration(selectedPartner?.PartnerName)">
                <app-change-log-link-entity type="Partner" [id]="$safeNavigationMigration(selectedPartner?.PartnersId)"></app-change-log-link-entity>
              </app-change-log-link>
            </div>
          </div>
        </div>

        <div class="btn-toolbar">
          @if (!isEditing) {
            <div class="btn-group">
              <button id="btnExportPartner" class="btn btn-primary btn-sm" *bizPermissionRequired="'Partner_Action_PartnerExport'" [disabled]="!selectedPartner || !selectedPartner.PartnersId" (click)="export()">Export</button>
            </div>
          }
          <div class="btn-group">
            <button id="btnDelete" class="btn btn-primary btn-sm" *bizPermissionRequired="['Partner_Action_PartnerDelete','Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: this.selectedPartner" [disabled]="!selectedPartner || isEditing" (click)="delete()">Delete</button>
          </div>
        </div>

        <h2 style="display: inline-block">{{selectedPartner?.PartnerName}} @if (selectedPartner?.IsProxyPartner) {
          <span class="label label-info">Proxy Partner</span>
          }</h2>&nbsp;&nbsp;<span class="label label-default">{{selectedPartner?.PartnerType?.Name}}</span>

          <div class="form-group btn-info-container " data-toggle="buttons" [hidden]="!partners || partners?.length < 2">

            @for (partner of partners; track partner) {
              <label class="btn btn-info-button" [class.active]="selectedPartner?.PartnersId === partner?.PartnersId" style="width: 220px !important">
                <input [disabled]="isEditing" type="radio" [value]="partner" [ngModel]="selectedPartner" (ngModelChange)="selectedPartnerChanged(partner)">
                <span class="PartnerIn">{{partner?.PartnerName}}<button class="btn btn-sm pull-right" (click)="removePartner(partner)" [disabled]="isEditing" title="Close partner">X</button></span>
                <span class="hr"></span>
                <span class="IdentificationType">{{partner?.MainIdentificationType?.IdentificationType?.Name}}</span>
                <span class="id">{{partner?.MainIdentificationType?.Value}}</span>
                <span class="PartnerOut">{{partner?.EdiPortalId}}</span>
                <span class="PartnerOut">{{partner?.PartnerType?.Name}}</span>
              </label>
            }
          </div>

          <div class="nav-tabs-filter">
            <ul ngbNav class="nav-tabs" [(activeId)]="selectedTab">
              <li ngbNavItem="general" *bizPermissionRequired="'Partner_Action_GeneralShow'">
                <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">General</a>
              </li>
              <li ngbNavItem="configurations" *bizPermissionRequired="'Partner_Action_EdiConfigurationsShow'">
                <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">EDI Configurations</a>
              </li>
              <li ngbNavItem="identifications" *bizPermissionRequired="'Partner_Action_IdentificationShow'">
                <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Identification</a>
              </li>
              <li ngbNavItem="contacts" *bizPermissionRequired="'Partner_Action_ContactsShow'">
                <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Contacts</a>
              </li>
              <li ngbNavItem="configurationKeys" *bizPermissionRequired="'Partner_Action_ConfigurationKeysShow'">
                <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Configuration Keys</a>
              </li>
              <li ngbNavItem="locations" *bizPermissionRequired="'Transport_View_OutgoingLocation_List'">
                <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Locations</a>
              </li>
              <li ngbNavItem="conversions" *bizPermissionRequired="'Partner_Action_ConversionTablesShow'">
                <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Conversions</a>
              </li>
              <li ngbNavItem="ftp" *bizPermissionRequired="'Partner_Action_FtpShow'">
                <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Ftp</a>
              </li>
              <li ngbNavItem="certificates" *bizPermissionRequired="'Partner_Action_CertificateShow'">
                <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Certificates</a>
              </li>
              @if(showTags){
                <li ngbNavItem="tags" *bizPermissionRequired="['Partner_Action_GeneralShow','Partner_View_Tags']">
                  <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Tags</a>
                </li>
              }
              @if (showProxyPartner) {
                <li ngbNavItem="proxy">
                  <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Proxy Settings</a>
                </li>
              }

              @if (showOnbording) {
                <li ngbNavItem="onboarding" *bizPermissionRequired="'Partner_View_Onboarding'">
                  <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Onboarding Setup</a>
                </li>
                <li ngbNavItem="onboarding-details" *bizPermissionRequired="'Partner_View_Onboarding'">
                  <a ngbNavLink class="btn" [attr.disabled]="isEditing ? '' : null">Onboarding Details</a>
                </li>
              }
            </ul>
          </div>

          <ep-partner-details-general [hidden]="selectedTab !== 'general'" #partnerComponentGeneral></ep-partner-details-general>
          <ep-partner-details-configurations [hidden]="selectedTab !== 'configurations'" #partnerComponentConfigurations></ep-partner-details-configurations>
          <ep-partner-details-identifications [hidden]="selectedTab !== 'identifications'" #partnerComponentIdentifications></ep-partner-details-identifications>
          <ep-partner-details-contacts [hidden]="selectedTab !== 'contacts'" #partnerComponentContacts></ep-partner-details-contacts>
          <ep-partner-details-configuration-keys [hidden]="selectedTab !== 'configurationKeys'" #partnerComponentConfigurationKeys></ep-partner-details-configuration-keys>
          <ep-partner-details-locations [hidden]="selectedTab !== 'locations'" #partnerComponentLocations></ep-partner-details-locations>
          <ep-partner-details-conversiontables [hidden]="selectedTab !== 'conversions'" #partnerComponentConversions></ep-partner-details-conversiontables>
          <ep-partner-details-ftp [hidden]="selectedTab !== 'ftp'" #partnerComponentFtp></ep-partner-details-ftp>
          <ep-partner-details-tags [hidden]="selectedTab !== 'tags'" #partnerComponentTags></ep-partner-details-tags>
          <ep-partner-details-certificates [hidden]="selectedTab !== 'certificates'" #partnerComponentCertificates></ep-partner-details-certificates>
          @if(showOnbording){
            <ep-partner-details-onboarding [hidden]="selectedTab !== 'onboarding'" #partnerComponentOnboarding (refresh)="refresh(false,false)"></ep-partner-details-onboarding>
            <ep-partner-details-onboarding-details [hidden]="selectedTab !== 'onboarding-details'" #partnerComponentOnboardingDetails (refresh)="refresh(false,false)" (changeTab)="onChangeTab($event)"></ep-partner-details-onboarding-details>
          }
          <ep-partner-details-proxy-partners [hidden]="selectedTab !== 'proxy'" #partnerComponentProxyPartners></ep-partner-details-proxy-partners>
        }

        @if(isCreatingNew === true){
          <app-new-partner (saved)="newPartnerSaved($event)" (cancelled)="newPartnerCancelled()"></app-new-partner>
        }

        @if(isCreatingNewOnboarding === true){
          <ep-partner-details-onboarding #partnerComponentOnboarding (saved)="newPartnerSaved($event)" (cancelled)="newPartnerCancelled()" [isNewPartner]="true"></ep-partner-details-onboarding>
        }

